import { render, staticRenderFns } from "./StatsBar.vue?vue&type=template&id=bfd46dda&scoped=true&lang=pug&"
import script from "./StatsBar.vue?vue&type=script&lang=js&"
export * from "./StatsBar.vue?vue&type=script&lang=js&"
import style0 from "./StatsBar.vue?vue&type=style&index=0&id=bfd46dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd46dda",
  null
  
)

export default component.exports